import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/state/store';
import { referralAPI } from '@samclick-static-urls';
import { sendGet, sendPut, sendPost } from '@samclick-api-client';
import Payload from './payload';


class ReferralState {
    public loading: boolean = false

    public referral: object[] = {}
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'referral',
})
class ReferralStore extends VuexModule {
    referralStore: ReferralState = new ReferralState();

    @Mutation
    REFERRAL_REINITIALIZE() {
        this.referralStore = new ReferralState();
    }

    @Mutation
    SET_REFERRAL_LOADING(loading: boolean) {
        this.referralStore.loading = loading;
    }

    @Mutation
    SET_REFERRAL_SEARCH(response: object) {
        this.referralStore.referral = response || {};
    }

    @Action({ rawError: true })
    showLoader(show: boolean) {
        this.context.commit('SET_REFERRAL_LOADING', show);
    }

    @Action({ rawError: true })
    destroyReferral() {
        this.context.commit('REFERRAL_REINITIALIZE');
    }

  @Action({ rawError: true })
    getReferral(payload: Payload = new Payload()) {
        this.showLoader(payload.activateLoader);
        return new Promise((resolve, reject) => {
            sendGet(referralAPI.getReferral, payload.data).then((response) => {
                if (payload.storeData) {
                    this.context.commit('SET_REFERRAL_SEARCH', response.data);
                }
                this.showLoader(false);
                resolve(response);
            }, (error) => {
                this.showLoader(false);
                reject(error.response);
            });
        });
    }

  @Action({ rawError: true })
  saveReferralMaster(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPost(referralAPI.saveReferralMaster, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }
}

export default getModule(ReferralStore);
